// ======================================================================
// File Name       : EmailRegisterEditForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { VALIDATE_TYPE } from '../../constants/index';
import RenderField from '../../utils/ReduxFormUtils';

class EmailRegisterEditForm extends React.Component {

  render() {
    const {
      emailTitle,
      emailContents,
      emailReplyTo,
      onChangeCheckbox,
      isReservation,
      handleAddDestinationUsers,
      emailReceiverList,
    } = this.props;
    const selectedUser = (emailReceiverList && Object.keys(emailReceiverList).length) || 0;
    const isCheckEmail = emailReplyTo !== '';
    return (
      <div>
        <Col sm={12} className="margin-top-10">
          <Form.Group className="form-info label-middle">
            <Col as={Form.Label} sm={3}>
              件名<span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={7} className="padding-bottom-7">
              <RenderField
                type="text"
                name="emailTitle"
                label="件名"
                maxLength="256"
                validates={[VALIDATE_TYPE.REQUIRED]}
                value={emailTitle}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info label-middle">
            <Col as={Form.Label} sm={3}>
              本文<span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={7}>
              <RenderField
                type="textarea"
                label="本文"
                rows={15}
                name="emailContents"
                validates={[VALIDATE_TYPE.REQUIRED]}
                value={emailContents}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info label-middle margin-top-7">
            <Col className="form-label" sm={3}>
              返信時の宛先
            </Col>
            <Col sm={7} className="padding-bottom-7">
              <RenderField
                type="text"
                name="emailReplyTo"
                label="返信時の宛先"
                maxLength="256"
                validates={isCheckEmail ? [VALIDATE_TYPE.EMAIL] : []}
                value={emailReplyTo}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info label-middle">
            <Col className="form-label" sm={12}>
              <RenderField
                type="checkbox"
                label="送信予約をする"
                name="reservedFlag"
                className="padding-top-clear"
                radioChange={onChangeCheckbox}
                checkRadioChange
              />
              {isReservation && (
                <Col sm={12}>
                  <Col className="padding-left-30 padding-top-10" sm={3}>
                    予約日時
                  </Col>
                  <Col className="padding-left-clear" style={{ transform: 'translateX(-10px)' }} sm={3}>
                    <RenderField
                      name="reservedDate"
                      type="datetime"
                      label="予約日時"
                      validates={[
                        VALIDATE_TYPE.DATE_TIME,
                        VALIDATE_TYPE.REQUIRED,
                      ]}
                      normalizeDateTime
                      shouldDisableDate
                      showHour
                    />
                  </Col>
                </Col>
              )}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col className="form-label" sm={3}>
              送信先ユーザー<span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={7} className="padding-bottom-7">
              <Col>
                <Button
                  variant="primary"
                  className="btn-96"
                  type="button"
                  onClick={handleAddDestinationUsers}
                >
                  選択
                </Button>
              </Col>
              <Col className="margin-top-15">
                選択中ユーザー数：{selectedUser}人
                {selectedUser === 0 &&
                  <RenderField
                    name="emailReceiverList"
                    type="requiredarray"
                    validates={[VALIDATE_TYPE.REQUIRED_ARRAY]}
                    label="送信先ユーザー"
                    keyArrayToCheck="selectedUser"
                  />
                }
              </Col>
            </Col>
          </Form.Group>
        </Col>
      </div>
    );
  }
}

export default EmailRegisterEditForm;
